/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour Palette Generator (Harmonies) — Toolverse`)
};

const es_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Interés Compuesto — Haz Crecer tus Ahorros | Toolverse`)
};

const de_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zinseszinsrechner — Ersparnisse vermehren | Toolverse`)
};

const nl_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculator voor samengestelde rente — Spaargeld laten groeien | Toolverse`)
};

const fr_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'intérêt composé — Augmentez votre épargne | Toolverse`)
};

const it_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'Interesse Composto — Fai crescere i tuoi risparmi | Toolverse`)
};

const pt_br2_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Juros Compostos — Aumentar Poupança | Toolverse`)
};

const pt_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Juros Compostos — Aumente a sua Poupança | Toolverse`)
};

const ja_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利計算ツール — 貯金を成長させる | Toolverse`)
};

const zh_cp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利计算器 — 让储蓄增长 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_meta_title", locale)
	if (locale === "en") return en_cp_meta_title(inputs)
	if (locale === "es") return es_cp_meta_title(inputs)
	if (locale === "de") return de_cp_meta_title(inputs)
	if (locale === "nl") return nl_cp_meta_title(inputs)
	if (locale === "fr") return fr_cp_meta_title(inputs)
	if (locale === "it") return it_cp_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cp_meta_title(inputs)
	if (locale === "pt") return pt_cp_meta_title(inputs)
	if (locale === "ja") return ja_cp_meta_title(inputs)
	return zh_cp_meta_title(inputs)
};